























import { Component, Vue, Emit, Prop } from 'vue-property-decorator';
import { ALL_DEPARTMENTS } from '@/queries/Department';
import { GQL_deleteDepartment_deleteDepartment_department } from '@/queries/__generated__/deleteDepartment';
import { InMemoryCache } from 'apollo-cache-inmemory';
import { GQL_currentUnitDepartments, GQL_currentUnitDepartments_currentUnit_departments } from '@/queries/__generated__/currentUnitDepartments';
import gql from 'graphql-tag';

const DELETE_DEPARTMENT = gql`
  mutation deleteDepartment($id: ID!) {
    deleteDepartment(
      input: {
        id: $id,
      }
    ) {
      department {
        id
      }
    }
  }
`;

@Component
export default class DepartmentDeleteButton extends Vue {
  @Prop() public department!: GQL_currentUnitDepartments_currentUnit_departments;
  public DELETE_DEPARTMENT = DELETE_DEPARTMENT;

  @Emit('department-deleted')
  public removeFromCache(
    store: InMemoryCache,
    { data: { deleteDepartment: { department } } }: {data: {deleteDepartment: {department: GQL_deleteDepartment_deleteDepartment_department}} },
  ) {
    const data = (store.readQuery({ query: ALL_DEPARTMENTS }) as GQL_currentUnitDepartments);
    data.currentUnit.departments = data.currentUnit.departments.filter(c => c.id !== department.id);
    store.writeQuery({ query: ALL_DEPARTMENTS, data });
  }

  public confirmDelete(confirmMutation: () => {}) {
    this.$sPopup.confirm(``, {
      title: this.$t('PopupTitle.confirmDelete'),
      message: this.$t('PopupBody.confirmDelete', { thing: `${this.department.code} - ${this.department.name}` }),
      onConfirm: confirmMutation,
    });
  }
}
